import { render, staticRenderFns } from "./OrderListExchangeSuccess.vue?vue&type=template&id=65ce1b85&scoped=true"
import script from "./OrderListExchangeSuccess.vue?vue&type=script&lang=js"
export * from "./OrderListExchangeSuccess.vue?vue&type=script&lang=js"
import style0 from "./OrderListExchangeSuccess.vue?vue&type=style&index=0&id=65ce1b85&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce1b85",
  null
  
)

export default component.exports